import { render, staticRenderFns } from "./ButtonFilterMenuOptions.vue?vue&type=template&id=00d54ad4"
import script from "./ButtonFilterMenuOptions.vue?vue&type=script&lang=ts"
export * from "./ButtonFilterMenuOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports